<template>
  <v-form ref="form" v-model="formComplete" :value="formValid">
    <v-container class="billingContainer">
      <div class="billingText">
        <div class="billingTextTitle">{{ billingTitle }}</div>
        <div class="billingTextInfo"> {{ billingDescription }}
        </div>
      </div>
      <v-layout row wrap class="form">
        <v-flex order-xs2 order-md2 order-lg1 x12 md12 lg8>
          <v-layout row wrap>
            <v-flex xs12 md6 lg6>
              <v-text-field
                class="billingInputField"
                :class="{
                  'mr-2': $vuetify.breakpoint.mdAndUp,
                }"
                :value="firstName"
                label="First Name"
                name="first-name"
                @input="$emit('update:firstName', $event)"
                :rules="[rules.required]"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 lg6>
              <v-text-field
                class="billingInputField"
                :value="lastName"
                label="Last Name"
                name="last-name"
                @input="$emit('update:lastName', $event)"
                :rules="[rules.required]"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field
                class="billingInputField"
                :value="number"
                label="Credit Card Number"
                :rules="[rules.required]"
                @input="$emit('update:number', $event)"
                outline
                name="number"
                autocomplete="cc-number"
            ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 md3>
              <v-text-field
                class="mr-2 billingInputField"
                :value="expireMonth"
                label="EXP. MM"
                name="expireMonth"
                :maxlength="2"
                @input="$emit('update:expireMonth', $event)"
                :rules="[expireMMValidation]"
                outline
                autocomplete="cc-exp-month"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 md3>
              <v-text-field
                class="billingInputField"
                :class="{
                  'mr-2': $vuetify.breakpoint.mdAndUp,
                }"
                :value="expireYear"
                label="EXP. YY"
                name="expireYear"
                :maxlength="2"
                @input="$emit('update:expireYear', $event)"
                :rules="[expireYYValidation]"
                outline
                autocomplete="cc-exp-year"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                class="billingInputField"
                :value="cvv"
                label="CVV"
                name="cvc"
                autocomplete="cc-csc"
                :maxlength="4"
                @input="$emit('update:cvv', $event)"
                :rules="[rules.cvv]"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex order-xs1 order-md1 order-lg2 xs12 md12 lg4>
          <div class="card-wrapper"></div>
          <v-layout justify-center>
            <v-layout row wrap class="icon-container">
              <v-flex
                v-for="(img, index) in cardImages"
                :key="img"
                d-flex
                class="center-img"
              >
                <v-img
                  :max-width="index == 0 ? 100 : 50"
                  :style="[index === 0 ? {transform: 'scale(1.5)'} : {}]"
                  contain
                  :src="img">
                </v-img>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import Card from 'card';
import amex from 'assets/card-american-express.svg';
import discover from 'assets/card-discover.svg';
import mc from 'assets/card-mc_vrt_pos.svg';
import ssl from 'assets/card-SSLSecure_icon.svg';
import visa from 'assets/card-Visa_Inc._logo.svg';

export default {
  props: {
    customerInfo: {
      type: Object,
      default: () => {},
    },
    isComplete: {
      type: Boolean,
      default: false,
    },
    validateForm: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    number: {
      type: String,
      default: '',
    },
    expireMonth: {
      type: String,
      default: '',
    },
    expireYear: {
      type: String,
      default: '',
    },
    cvv: {
      type: String,
      default: '',
    },
    billingTitle: {
      type: String,
      default: 'Billing Information',
    },
    billingDescription: {
      type: String,
      default: 'Please complete the required billing information below and click “Protect Your Purchase”.',
    },
  },
  data: () => ({
    formValid: false,
    rules: {
      required: value => !!value || 'Required.',
      cvv: value => value.length >= 3 || 'Must be 3 characters or more.',
    },
    formComplete: false,
    cardImages: [
      ssl,
      mc,
      amex,
      discover,
      visa,
    ],
  }),
  mounted() {
    window.jQuery = window.$;
    /* eslint-disable */
    new Card({
      form: '.form',
      container: '.card-wrapper',
      formSelectors: {
        nameInput: 'input[name="first-name"], input[name="last-name"]',
      },
    });
    /* eslint-enable */

    if (this.firstName && this.lastName) {
      this.injectName();
    }
  },
  methods: {
    /* eslint-disable */
    expireMMValidation: function (date) {
      let valid = true;
      let errorMessage = 'Expiration MM must be between 01 and 12.';
      const currentMonth = new Date().getMonth();
      const currentYear = new Date().getFullYear().toString().substr(-2);

      if (date < 1 || date > 12) {
        valid = false;
        this.$emit('update:isComplete', false);
      }

      if (date.length < 2) {
        valid = false;
        this.$emit('update:isComplete', false);
        errorMessage = 'Exp MM must be 2 digits';
      }

      // CurrentYear needs to be change to this.expireYY in order for this to be complete
      if (date < currentMonth && this.expireYear === currentYear) {
        valid = false;
        errorMessage = 'Exp MM must be greater than or equal to the current month.';
        this.$emit('update:isComplete', false);
      }

      return valid || errorMessage;
    },
    expireYYValidation: function (date) {
      let valid = true;
      const currentYear = new Date().getFullYear().toString().substr(-2);
      const lastYear = (currentYear - 1).toString();
      let errorMessage = `Expiration YY must be greater than ${lastYear}.`;

      if (date.toString() < currentYear) {
        valid = false;
        this.$emit('update:isComplete', false);
      }

      if (date.length < 2) {
        valid = false;
        this.$emit('update:isComplete', false);
        errorMessage = 'Exp YY must be 2 digits';
      }

      return valid || errorMessage;
    },
    /* eslint-enable */
    injectExpiry() {
      const expireField = document.getElementsByClassName('jp-card-expiry')[0];
      if (this.expireYear && this.expireMonth) {
        expireField.textContent = `${this.expireMonth}/${this.expireYear}`;
      }
    },
    injectName() {
      const nameField = document.getElementsByClassName('jp-card-name')[0];
      if (this.firstName && this.lastName) {
        nameField.textContent = `${this.firstName} ${this.lastName}`;
      }
    },
  },
  computed: {
    isFormCompleted() {
      let value = false;
      if (
        this.firstName
        && this.lastName
        && this.number
        && this.expireMonth
        && this.expireYear
        && this.cvv
      ) {
        value = true;
      }
      return value;
    },
  },
  watch: {
    formComplete(isComplete) {
      if (isComplete && this.isFormCompleted) {
        const isValid = this.$refs.form.validate();
        this.$emit('update:isComplete', isValid);
      } else {
        this.$emit('update:isComplete', false);
      }
    },
    expireMonth(value) {
      if (value && this.expireYear) {
        this.injectExpiry();
      }
    },
    expireYear(value) {
      if (value && this.expireMonth) {
        this.injectExpiry();
      }
    },
    firstName(value) {
      if (value && this.lastName) {
        this.injectName();
      }
    },
    lastName(value) {
      if (value && this.firstname) {
        this.injectName();
      }
    },
    isFormCompleted(value) {
      const isValid = this.$refs.form.validate();
      if (value && isValid) {
        this.formValid = true;
      } else {
        this.formValid = false;
        this.$emit('update:isComplete', false);
      }
    },
    validateForm(value) {
      if (value) {
        this.$refs.form.validate();
        this.$nextTick(() => {
          this.$emit('update:validateForm', false);
        });
      }
    },
  },
};
</script>

<style>
.icon-container {
  max-width: 335px;
}
.center-img {
  justify-content: center;
}

.billingContainer {
  width: 1068px;
  height: 365px;
  margin-top: 40px;
  border-radius: 12px;
  background-color: #f2f2f2;
  padding: 24px;
}

.billingTextTitle {
  font-family: Gotham;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333333;
}

.billingTextInfo {
  font-family: Gotham;
  font-size: 16px;
  text-align: left;
  color: #000000;
  margin-bottom: 10px;
}

.billingInputField {
  font-family: Gotham;
  font-size: 16px;
  color: #999999;
}

.card-wrapper > .jp-card-container > .jp-card{
  min-width: 0px !important;
}

.card-wrapper > .jp-card-container > .jp-card
 > .jp-card-front > .jp-card-lower > .jp-card-number {
  font-size: 21px !important;
}

 /* Extra large Break Point */
@media screen and (min-width: 1904px) {
  .billingContainer {
    width: 1160px;
  }
}

 /* Tablet Break Point */
@media screen and (max-width: 1264px) {
  .billingContainer {
    width: 688px;
    height: 615px;
  }
}

 /* Mid Phone to Tablet Break Point */
@media screen and (min-width: 767px) and (max-width: 959px) {
  .billingContainer {
    height: 785px;
  }
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .billingContainer {
    width: 281px;
    height: 840px;
  }

  .billingText {
    padding-top: 10px;
  }

  .card-wrapper > .jp-card-container > .jp-card
 > .jp-card-front > .jp-card-lower > .jp-card-number {
  font-size: 19px !important;
  }
}
</style>
